module.exports = __webpack_public_path__ + "assets/img/headPortrait.b91b8120.png";